import type { EntryGatePageViewModel } from '@adapters/presenters/EntryGatePresenter';
import { EntryGatePresenter } from '@adapters/presenters/EntryGatePresenter';
import { GetEntryGateStatusUseCase } from '@core/usecases/GetEntryGateStatusUseCase';

export class EntryGateController {
  public constructor(
    private readonly getEntryGateStatusUseCase: GetEntryGateStatusUseCase,
    private readonly entryGatePresenter: EntryGatePresenter
  ) {}

  public async load(): Promise<EntryGatePageViewModel> {
    const status = await this.getEntryGateStatusUseCase.execute();
    return this.entryGatePresenter.presentStatus(status);
  }
}